// Import the specific helper function needed from your api.js file
// Adjust the path '../api' if your file structure is different
import { callUnprotectedApi } from '../api';

// --- Authentication API Calls ---

/**
 * Sends login credentials to the backend using the unprotected helper.
 * @param {object} credentials - { emailOrUsername: '...', password: '...' } or similar
 * @returns {Promise} Axios response promise from callUnprotectedApi
 */
const login = (credentials) => {
  // Endpoint path starts after '/api' because BASE_URL in api.js includes it.
  // Adjust '/auth/login' if your specific endpoint is different.
  return callUnprotectedApi('/auth/login', 'post', credentials);
  // Expected backend response often includes: { token: '...', user: {...} }
};

/**
 * Sends registration data to the backend using the unprotected helper.
 * @param {object} userData - { username: '...', email: '...', password: '...' } or similar
 * @returns {Promise} Axios response promise from callUnprotectedApi
 */
const register = (userData) => {
  // Adjust '/auth/register' if your endpoint is different
  return callUnprotectedApi('/auth/register', 'post', userData);
  // Expected backend response might include: { message: 'Registration successful...' }
};

/**
 * Sends forgot password request to the backend using the unprotected helper.
 * @param {object} emailData - { email: '...' }
 * @returns {Promise} Axios response promise from callUnprotectedApi
 */
const forgotPassword = (emailData) => {
  // Adjust '/auth/forgot-password' if your endpoint is different
  return callUnprotectedApi('/auth/forgot-password', 'post', emailData);
  // Expected backend response might include: { message: 'Password reset link sent...' }
};

/**
 * Sends new password and reset token to the backend using the unprotected helper.
 * @param {string} token - The password reset token (usually from URL query)
 * @param {object} passwordData - { password: '...' }
 * @returns {Promise} Axios response promise from callUnprotectedApi
 */
const resetPassword = (token, passwordData) => {
  // Adjust '/auth/reset-password'. Assumes token is sent in the body.
  return callUnprotectedApi('/auth/reset-password', 'post', { token, ...passwordData });
  // Expected backend response might include: { message: 'Password reset successful...' }
};

/**
 * Sends request to resend verification email using the unprotected helper.
 * @param {object} emailData - { email: '...' }
 * @returns {Promise} Axios response promise from callUnprotectedApi
 */
const resendVerification = (emailData) => {
    // Adjust '/auth/resend-verification' if your endpoint is different
    return callUnprotectedApi('/auth/resend-verification', 'post', emailData);
     // Expected backend response might include: { message: 'Verification email sent...' }
}

// Export the functions
export default {
  login,
  register,
  forgotPassword,
  resetPassword,
  resendVerification,
};